import React from 'react';
import Input from '../../../components/ui/Input';
import Select from '../../../components/ui/Select';

const ItemDetailsForm = ({ formData, errors, onChange }) => {
  const statusOptions = [
    { value: 'great', label: 'Great Condition' },
    { value: 'good', label: 'Good Condition' },
    { value: 'damaged', label: 'Damaged' }
  ];

  const deliveryStatusOptions = [
    { value: 'in_warehouse', label: 'In Warehouse' },
    { value: 'in_route', label: 'In Route' },
    { value: 'delivered', label: 'Delivered' }
  ];

  const warehouseLocationOptions = [
    { value: 'Portland, OR', label: 'Portland, OR' },
    { value: 'Seattle, WA', label: 'Seattle, WA' },
    { value: 'Los Angeles, CA', label: 'Los Angeles, CA' },
    { value: 'San Francisco, CA', label: 'San Francisco, CA' },
    { value: 'Nashville, TN', label: 'Nashville, TN' },
    { value: 'Coming Soon', label: 'Coming Soon' }
  ];

  const handleChange = (field, value) => {
    onChange({ ...formData, [field]: value });
  };

  return (
    <div className="space-y-6">
      <div>
        <Input
          label="Furniture Name"
          type="text"
          placeholder="Enter furniture name"
          value={formData?.name}
          onChange={(e) => handleChange('name', e?.target?.value)}
          error={errors?.name}
          required
          className="mb-4"
        />
      </div>
      <div>
        <Input
          label="LIIN (LaSea Inventory ID Number)"
          type="text"
          value={formData?.liin}
          disabled
          description="Auto-generated unique identifier"
          className="mb-4"
        />
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        <div>
          <Select
            label="Condition Status"
            options={statusOptions}
            value={formData?.status}
            onChange={(value) => handleChange('status', value)}
            error={errors?.status}
            required
            placeholder="Select condition"
          />
        </div>
        <div>
          <Select
            label="Warehouse Location"
            options={warehouseLocationOptions}
            value={formData?.location || 'Portland, OR'}
            onChange={(value) => handleChange('location', value)}
            error={errors?.location}
            placeholder="Select location"
          />
        </div>
      </div>

      <div>
        <Select
          label="Delivery Status"
          options={deliveryStatusOptions}
          value={formData?.deliveryStatus}
          onChange={(value) => handleChange('deliveryStatus', value)}
          error={errors?.deliveryStatus}
          required
          placeholder="Select status"
        />
      </div>
      <div>
        <Input
          label="Arrival Date"
          type="date"
          value={formData?.arrivalDate}
          onChange={(e) => handleChange('arrivalDate', e?.target?.value)}
          error={errors?.arrivalDate}
          required
          className="mb-4"
        />
      </div>
      <div>
        <Input
          label="Item Value"
          type="number"
          placeholder="Enter item value"
          value={formData?.itemValue}
          onChange={(e) => handleChange('itemValue', e?.target?.value)}
          error={errors?.itemValue}
          description="Estimated current value of the item"
          className="mb-4"
        />
      </div>
      <div>
        <label className="block text-sm font-medium text-foreground mb-2">
          Notes <span className="text-muted-foreground">(Optional)</span>
        </label>
        <textarea
          value={formData?.notes}
          onChange={(e) => handleChange('notes', e?.target?.value)}
          placeholder="Add any additional notes about this item..."
          rows={4}
          className="w-full px-4 py-3 bg-background border border-input rounded-lg text-foreground placeholder:text-muted-foreground focus:outline-none focus:ring-2 focus:ring-ring transition-smooth resize-none"
        />
        <p className="text-xs text-muted-foreground mt-2">
          Status, condition, and location changes are automatically logged here with timestamps.
        </p>
        {errors?.notes && (
          <p className="text-xs text-error mt-1">{errors?.notes}</p>
        )}
      </div>
    </div>
  );
};

export default ItemDetailsForm;